<template>
  <div>
    <div class="q-ma-sm text-subtitle1">Scan barcode</div>
    <div class="row justify-center">
      <StreamBarcodeReader
        class="scanner"
        @decode="onDecode"
        @loaded="onLoaded"
      ></StreamBarcodeReader>
    </div>

    <div class="q-ma-sm row justify-between">
      <q-input outlined dense class="col-10" color="primary" v-model="code">
        <template v-slot:append>
          <q-icon name="close" @click="code = ''" class="cursor-pointer" />
        </template>
      </q-input>
      <q-btn class="col-2" label="Search" flat no-caps color="primary" @click="onDecode(code)"> </q-btn>
    </div>

    <div class="q-ma-sm text-subtitle1">Result</div>

    <div class="row" style="padding: 0px 0px 0px 0px">
      <div class="row full-width">
        <ProductCardH
          :style="`padding: 4px; border:`"
          class="product-card-h col-xs-12 col-sm-6 col-md-4"
          v-for="(item, index) in list"
          :key="(item.cprcode << 16) + index"
          :info="item"
          :maxRetry="10"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import axios from "axios";
import ProductCardH from "@/ui/components/ProductCardH.vue";
export default {
  name: "Scan",
  components: {
    StreamBarcodeReader,
    ProductCardH,
  },
  data() {
    return {
      list: [],
      code: null,
    };
  },
  methods: {
    onLoaded(result) {
      console.log(result);
    },
    async onDecode(decodedString) {
      console.log(decodedString);
      this.code = decodedString;
      const response = await axios.post(
        "https://pxa8yt7750.execute-api.ap-southeast-1.amazonaws.com/Prod/getCprcodeByBarcode",
        {
          barcode: decodedString,
        }
      );
      if (response.data) {
        if (response.data.cprcode) {
          if (response.data.cprcode > 0) {
            if (this.$services.catalog.productMap) {
              const product = this.$services.catalog.productMap.get(
                response.data.cprcode
              );
              if (product && product.availableStore.get(1000)) {
                // prevent duplicate
                const found = this.list.some(
                  (p) => p.cprcode === response.data.cprcode
                );
                if (!found) {
                  this.list.push(product);
                }
              }
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
/* .scanner {
  min-height: 200px;
} */

div >>> video[data-v-9c322c14] {
    height: 30vh !important;
    max-width: none;
    max-height: none;
}
</style>
